import React, { type ComponentType, useEffect, useState } from 'react';

interface WithActiveProps {
  isActive: boolean;
}

const withActive = <T,>(Component: ComponentType<T & WithActiveProps>) => {
  const WrappedComponent = (props: T & WithActiveProps) => {
    const { isActive } = props;

    const [isMounted, setIsMounted] = useState<boolean>();

    const handleActive = () => {
      if (isActive) return setIsMounted(true);

      if (typeof isMounted != 'undefined')
        setTimeout(() => setIsMounted(false), 150);
    };

    useEffect(handleActive, [isActive]);
    return <>{isMounted && <Component {...props} />}</>;
  };

  WrappedComponent.displayName = `withActive(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
};

export { withActive };
